import { FC, useEffect, useState } from "react";
import { PageHeadMedia } from "../../../components/layout";
import { LatestNewsWidget } from "../../../widgets/news/LatestNews";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { TeamContext } from "../../../types/common";
import { getNewsItem } from "../../../api/transport/newsTransport";
import { NewsDto } from "../../../types/news";
import { getStaticUrl } from "../../../utils";
import { NewsPhotos } from "./NewsPhotos";
import { SocialShare } from "../../../widgets/social/SocialShare";

const NewsItemPage: FC = () => {
    const config = useConfiguration();

    const match = globalThis?.location?.pathname?.match(/\/news\/(\d+)-/);
    const newsId = match?.[1] || -1;

    const [newsData, setNewsData] = useState<NewsDto>(null);

    useEffect(() => {
        if (newsId) {
            getNewsItem(+newsId, config.site).then(n => {
                setNewsData(n);
            });
        }
    }, [newsId]);


    let relatedCategory;

    if (config.teamName === TeamContext.RODINA_2) {
        relatedCategory = 8;
    } else if (config.teamName === TeamContext.RODINA_M) {
        relatedCategory = 6;
    }

    return (
        <div className="bg-white">
            {/*<PageHeadMedia
                mediaUrl={getStaticUrl(newsData?.image)}
            />
            <div className="p-2">
                <h1 className="text-xl font-bold text-center">{newsData?.title}</h1>
                <div
                    dangerouslySetInnerHTML={{
                        __html: newsData?.description
                    }}
                    className="w-full max-w-full py-4 text-lg"
                />
            </div>*/}
            {newsData && <div className="p-2 pb-8">
                <div className="flex flex-row gap-2 items-center text-xl py-3 border-0 border-t border-b border-solid border-slate-200">
                    <div>Рассказать друзьям:</div>
                    <SocialShare
                        title={newsData?.title}
                        description={newsData?.title}
                        imageUrl={newsData?.image}
                        url={globalThis.location.href}
                        keys={['vk', 'telegram', 'whatsapp', 'twitter']}
                        iconClassName="!w-9 !h-9"
                    />
                </div>
            </div>}
            <div className="p-2">
                <NewsPhotos linkUrl={newsData?.photoGallery?.url} photos={newsData?.photoGallery?.photos} />
            </div>
            <div className="p-2">
                <LatestNewsWidget
                    category={relatedCategory}
                    newsId={+newsId}
                />
            </div>
        </div>
    )
}

export default NewsItemPage;